var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C59C37"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6C10.2769 6 8.875 7.3458 8.875 9V10.2H8.25C7.56062 10.2 7 10.7382 7 11.4V16.8C7 17.4618 7.56062 18 8.25 18H15.75C16.4394 18 17 17.4618 17 16.8V11.4C17 10.7382 16.4394 10.2 15.75 10.2H15.125V9C15.125 7.3458 13.7231 6 12 6ZM10.125 9C10.125 8.0076 10.9662 7.2 12 7.2C13.0338 7.2 13.875 8.0076 13.875 9V10.2H10.125V9ZM15.7513 16.8H12.625V15.4332C12.9969 15.225 13.25 14.8422 13.25 14.4C13.25 13.7382 12.6894 13.2 12 13.2C11.3106 13.2 10.75 13.7382 10.75 14.4C10.75 14.8416 11.0031 15.225 11.375 15.4332V16.8H8.25V11.4H15.75L15.7513 16.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockNew);
export default __webpack_public_path__ + "static/media/lock-new.e5bffb2cdb9bddb03282d598c666b058.svg";
export { ForwardRef as ReactComponent };